export default class FeedAd {
  setAdDisplay(adParam, adsData) {
    if (typeof TagProvider === 'undefined') {
      if (newrelic) {
        this.sendNewRelicError('TagProvider is undefined');
      }
      return;
    }

    TagProvider.requestAds({
        sectionId: adParam.section,
        sync: false,
        custom:adParam.custom_param
    });

    for (let key in adsData) {
      const ad = document.getElementById(adsData[key].id);
      ad.insertAdjacentHTML(
        'afterbegin',
        `<div id="${adsData[key].ad_slot_id}_${adParam.section}">
          <script type="text/javascript">
            try {
              TagProvider.displayAd(\'${adsData[key].ad_slot_id}_${adParam.section}\');
            } catch (err) {
            }
          </script>
        </div>`
      );
    }
  }

  sendNewRelicError(message) {
    newrelic.noticeError(new Error(message));
  }
}
